module.exports = __webpack_public_path__ + "img/red-sticker.c107f5d.gif";